export class StudentStatus {
    id: string;
    name: string;
}

export const STUDENT_STATUS: StudentStatus[] = [
    {
        id: 'true',
        name: 'Active'
    },
    {
        id: 'false',
        name: 'Unactive'
    }
];




// WEBPACK FOOTER //
// ./src/holiday/models/StudentStatus.ts